import Api from '@/api/Api';

class CharityBoardRolesApi extends Api {
  constructor() {
    super('charities/positions/board-roles', 'charitiespositionsboard-roles');
  }
}
const charityBoardRolesApi = new CharityBoardRolesApi();
export default charityBoardRolesApi;
